import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { toast } from 'react-toastify';
import { Formik, Form, Field } from 'formik';

import { createNewUser } from '../utils/Api';
import { handleLoaderEvent } from '../utils/LoaderEmitter';

import * as Yup from 'yup';
import DatePicker from "react-datepicker";
import moment from "moment";

import '../styles/AddClient.css';

const AddClient = () => {

  const [newLicenseValue, setNewLicenseValue] = useState(1);
  const [newMonthValue, setNewMonthValue] = useState(1);
  const [startDate, setStartDate] = useState(new Date());
  const [newLicenseValueError, setNewLicenseValueError] = useState(false);
  const [newMonthValueError, setNewMonthValueError] = useState(false);
  const [rolesDetail, setRolesDetail] = useState({});

  let loggedInUserId = 0;

  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      let userDetail = localStorage.getItem('userDetail');
      userDetail = JSON.parse(userDetail);
      let detail = localStorage.getItem('roleDetail');
      detail = JSON.parse(detail)[0];
      setRolesDetail(detail);
      loggedInUserId = userDetail['id'];
    })();
  }, []);

  const newLicenseValueValidation = (licenseValue) => {
    if (parseInt(licenseValue) < 1) {
      setNewLicenseValueError(true)
    } else {
      setNewLicenseValueError(false)
    }
  }

  const newMonthValueValidation = (monthValue) => {
    if (parseInt(monthValue) < 1) {
      setNewMonthValueError(true)
    } else {
      setNewMonthValueError(false)
    }
  }

  const handleNewLicenseChange = (e) => {
    setNewLicenseValue((v) => (e.target.validity.valid ? e.target.value : v));
    newLicenseValueValidation()
  }

  const increaseNewLicense = () => {
    setNewLicenseValue(Number(newLicenseValue) + 1);
    newLicenseValueValidation(Number(newLicenseValue) + 1)
  }

  const decreaseNewLicense = () => {
    setNewLicenseValue((v) => (Number(newLicenseValue) > 0 ? Number(newLicenseValue) - 1 : v));
    newLicenseValueValidation(Number(newLicenseValue) - 1)
  }

  const handleNewMonthChange = (e) => {
    setNewMonthValue((v) => (e.target.validity.valid ? e.target.value : v));
    newMonthValueValidation(Number(e.target.value))
  }

  const increaseNewMonth = () => {
    setNewMonthValue(Number(newMonthValue) + 1);
    newMonthValueValidation(Number(newMonthValue) + 1)
  }

  const decreaseNewMonth = () => {
    setNewMonthValue((v) => (Number(newMonthValue) > 0 ? Number(newMonthValue) - 1 : v));
    newMonthValueValidation(Number(newMonthValue) - 1)
  }

  const saveNewUser = async (values) => {
    try {
      newLicenseValueValidation(newLicenseValue);
      newMonthValueValidation(newMonthValue);

      if (newLicenseValueError || newMonthValueError) {
        return;
      }
      handleLoaderEvent.emit('loader', true);
      let params = {
        "customer": {
          "name": values.name,
          "phone": values.phoneNumber,
          "website": values.website,
          "account_name": values.accountName,
          "domain_name": values.domainName,
          "email": values.email,
          "address": {
            "street": values.street,
            "city": values.city,
            "state": values.state,
            "country": values.country,
            "pin": values.pin
          },
          "projectInfo": {
            "name": values.projectName,
            "role": values.role,
            "department": values.department,
            "description": values.description
          },
          "createdBy": loggedInUserId,

          "customerAdmin": {
            "firstName": values.firstName,
            "lastName": values.lastName,
            "email": values.clientEmail,
            "country": values.clientCountry,
            "loginType": "EMAIL",
            "roles": [rolesDetail],
            "roleIds": [
              rolesDetail['id']
            ],
            "roleMapping": [
              null
            ],
            "createdBy": loggedInUserId,
            "phone": ""
          },
          "created_by": loggedInUserId
        },
        "license": {
          "number_of_licenses": newLicenseValue,
          "start_date": startDate,
          "expiry_date": "",
          "duration": newMonthValue
        },
        "customerAdmin": {
          "firstName": values.firstName,
          "lastName": values.lastName,
          "email": values.clientEmail,
          "country": values.clientCountry,
          "loginType": "EMAIL",
          "roles": [rolesDetail],
          "phone": "",
          "roleIds": [
            rolesDetail['id']
          ],
        }
      }
      let createdUser = await createNewUser(params);
      if (!createdUser) {
        return;
      }

      toast.info('Customer added successfully');
      navigate(`/platform-dashboard`);
    } catch (exception) {
      toast.error(exception?.response?.data?.message);
    } finally {
      handleLoaderEvent.emit('loader', false);
    }
  }

  const addClientSchema = Yup.object().shape({
    name: Yup.string().min(3, 'Name should be atleast 3 characters').required('This Field is Required'),
    website: Yup.string(),
    accountName: Yup.string().min(3, 'Account Name should be atleast 3 characters').required('This Field is Required'),
    domainName: Yup.string().matches(/^[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,6}$/i, "Invalid Domain").required('This Field is Required'),
    projectName: Yup.string(),
    department: Yup.string(),
    role: Yup.string(),
    description: Yup.string(),
    street: Yup.string(),
    city: Yup.string().matches(/^[a-zA-Z\s]+$/, "Invalid city name"),
    state: Yup.string().matches(/^[a-zA-Z\s]+$/, "Invalid state name"),
    pin: Yup.string().matches(/^[1-9][0-9]*$/, "Invalid pin"),
    country: Yup.string().matches(/^[a-zA-Z\s]+$/, "Invalid country name"),
    phoneNumber: Yup.string().matches(/^[1-9][0-9]*$/, "Invalid phone number"),
    email: Yup.string().matches(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/, "Invalid Email").required('This Field is Required'),
    firstName: Yup.string().min(3, 'First name should be alteast 3 characters').required('This Field is Required'),
    lastName: Yup.string().min(3, 'Last Name should be atleast 3 characters').required('This Field is Required'),
    clientCountry: Yup.string().matches(/^[a-zA-Z\s]+$/, "Invalid country name"),
    clientEmail: Yup.string().matches(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/, "Invalid Email").required('This Field is Required'),
    newLicenseValue: Yup.string(),
    newMonthValue: Yup.string(),
    startDate: Yup.string()
  });

  return (
    <div className='new-client'>
      <div className='new-title'>New Client</div>
      <div className='new-sub-title mt-4'>General Information<span className='new-title-small'>(Add Project Owner Details)</span></div>
      <div>
        <Formik
          initialValues={{
            name: '',
            website: '',
            accountName: '',
            domainName: '',
            projectName: '',
            department: '',
            role: '',
            description: '',
            street: '',
            city: '',
            state: '',
            pin: '',
            country: '',
            phoneNumber: '',
            email: '',
            firstName: '',
            lastName: '',
            clientCountry: '',
            clientEmail: '',
            newLicenseValue: '',
            newMonthValue: '',
            startDate: ''
          }}
          validationSchema={addClientSchema}
          onSubmit={values => {
            saveNewUser(values);
          }}>
          {({ errors, touched }) => (
            <Form>
              <div className='row p-0 m-0 w-100'>
                <div className='col-6 px-3 mt-4 new-input'>
                  <Field name="name" type="text" placeholder="Name*" />
                  {errors.name && touched.name ? (
                    <div className="invalid-text">{errors.name}</div>
                  ) : null}
                </div>
                <div className='col-6 px-3 mt-4 new-input'>
                  <Field name="website" type="text" placeholder="Website" />
                  {errors.website && touched.website ? (
                    <div className="invalid-text">{errors.website}</div>
                  ) : null}
                </div>
                <div className='col-6 px-3 mt-4 new-input'>
                  <Field name="accountName" type="text" placeholder="Account Name*" />
                  {errors.accountName && touched.accountName ? (
                    <div className="invalid-text">{errors.accountName}</div>
                  ) : null}
                </div>
                <div className='col-6 px-3 mt-4 new-input'>
                  <Field name="domainName" type="text" placeholder="Domain Name*" />
                  {errors.domainName && touched.domainName ? (
                    <div className="invalid-text">{errors.domainName}</div>
                  ) : null}
                </div>
              </div>
              <div className='new-sub-title mt-5'>Project Information<span className='new-title-small'>(Add Project Information)</span></div>
              <div className='row p-0 m-0 w-100'>
                <div className='col-6 px-3 mt-4 new-input'>
                  <Field name="projectName" type="text" placeholder="Project Name" />
                  {errors.projectName && touched.projectName ? (
                    <div className="invalid-text">{errors.projectName}</div>
                  ) : null}
                </div>
                <div className='col-6 px-3 mt-4 new-input'>
                  <Field name="department" type="text" placeholder="Department" />
                  {errors.department && touched.department ? (
                    <div className="invalid-text">{errors.department}</div>
                  ) : null}
                </div>
                <div className='col-6 px-3 mt-4 new-input'>
                  <Field name="role" type="text" placeholder="Role" />
                  {errors.role && touched.role ? (
                    <div className="invalid-text">{errors.role}</div>
                  ) : null}
                </div>
                <div className='col-6 px-3 mt-4 new-input'>
                  <Field name="description" type="text" placeholder="Description" />
                  {errors.description && touched.description ? (
                    <div className="invalid-text">{errors.description}</div>
                  ) : null}
                </div>
              </div>
              <div className='new-sub-title mt-5'>Contact Information</div>
              <div className='row p-0 m-0 w-100'>
                <div className='col-6 px-3 mt-4 new-input'>
                  <Field name="street" type="text" placeholder="Street" />
                  {errors.street && touched.street ? (
                    <div className="invalid-text">{errors.street}</div>
                  ) : null}
                </div>
                <div className='col-6 px-3 mt-4 new-input'>
                  <Field name="city" type="text" placeholder="City" />
                  {errors.city && touched.city ? (
                    <div className="invalid-text">{errors.city}</div>
                  ) : null}
                </div>
                <div className='col-6 px-3 mt-4 new-input'>
                  <Field name="state" type="text" placeholder="State" />
                  {errors.state && touched.state ? (
                    <div className="invalid-text">{errors.state}</div>
                  ) : null}
                </div>
                <div className='col-6 px-3 mt-4 new-input'>
                  <Field name="pin" type="text" placeholder="Pin" />
                  {errors.pin && touched.pin ? (
                    <div className="invalid-text">{errors.pin}</div>
                  ) : null}
                </div>
                <div className='col-6 px-3 mt-4 new-input'>
                  <Field name="country" type="text" placeholder="Country*" />
                  {errors.country && touched.country ? (
                    <div className="invalid-text">{errors.country}</div>
                  ) : null}
                </div>
                <div className='col-6 px-3 mt-4 new-input'>
                  <Field name="email" type="text" placeholder="Email*" />
                  {errors.email && touched.email ? (
                    <div className="invalid-text">{errors.email}</div>
                  ) : null}
                </div>
              </div>
              <div className='new-sub-title mt-5'>Client Admin</div>
              <div className='row p-0 m-0 w-100'>
                <div className='col-6 px-3 mt-4 new-input'>
                  <Field name="firstName" type="text" placeholder="First Name*" />
                  {errors.firstName && touched.firstName ? (
                    <div className="invalid-text">{errors.firstName}</div>
                  ) : null}
                </div>
                <div className='col-6 px-3 mt-4 new-input'>
                  <Field name="lastName" type="text" placeholder="Last Name*" />
                  {errors.lastName && touched.lastName ? (
                    <div className="invalid-text">{errors.lastName}</div>
                  ) : null}
                </div>
                <div className='col-6 px-3 mt-4 new-input'>
                  <Field name="clientCountry" type="text" placeholder="Client Country*" />
                  {errors.clientCountry && touched.clientCountry ? (
                    <div className="invalid-text">{errors.clientCountry}</div>
                  ) : null}
                </div>
                <div className='col-6 px-3 mt-4 new-input'>
                  <Field name="clientEmail" type="text" placeholder="Email*" />
                  {errors.clientEmail && touched.clientEmail ? (
                    <div className="invalid-text">{errors.clientEmail}</div>
                  ) : null}
                </div>
              </div>
              <div className='new-sub-title mt-5'>License</div>
              <div className='row p-0 m-0 w-100'>
                <div className='col-3'>
                  <div className='add-sub-title mt-3'>No of licenses*</div>
                  <div className='row p-0 m-0 mt-2 content-border'>
                    <div className='col-auto p-2 px-4 cursor-pointer' onClick={decreaseNewLicense}>
                      -
                    </div>
                    <div className='col p-0 p-2 content-border-left license-textbox'>
                      <input type="text" className='input-align' value={newLicenseValue} pattern="[0-9]*" onChange={handleNewLicenseChange}></input>
                    </div>
                    <div className='col-auto p-2 px-4 content-border-left cursor-pointer' onClick={increaseNewLicense}>
                      +
                    </div>
                  </div>
                  {newLicenseValueError && <span className='validation-errors'>Number of Licenses cannot be less than 1. </span>}
                </div>
                <div className='col-3 date-selector'>
                  <div className='add-sub-title mt-3'>Start Date*</div>
                  <DatePicker className='mt-2 w-100 input-align' selected={startDate} minDate={moment().toDate()} onChange={(date) => setStartDate(date)} />
                </div>
                <div className='col-3'>
                  <div className='add-sub-title mt-3'>Duration(Months)*</div>
                  <div className='row p-0 m-0 mt-2 content-border'>
                    <div className='col-auto p-2 px-4 cursor-pointer' onClick={decreaseNewMonth}>
                      -
                    </div>
                    <div className='col p-0 p-2 content-border-left license-textbox'>
                      <input type="text" className='input-align' value={newMonthValue} pattern="[0-9]*" onChange={handleNewMonthChange}></input>
                    </div>
                    <div className='col-auto p-2 px-4 content-border-left cursor-pointer' onClick={increaseNewMonth}>
                      +
                    </div>

                  </div>
                  {newMonthValueError && <span className='validation-errors'>Duration cannot be less than 1 month. </span>}
                </div>
              </div>
              <div className='d-flex justify-content-center mt-5'>
                <Link to="/platform-dashboard">
                  <button type='button' className='cancel-button p-2 px-4 me-3'>Cancel</button>
                </Link>
                <button type='submit' className='save-button p-2 px-4'>Save</button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  )
}

export default AddClient